import { render, staticRenderFns } from "./CheckpointHeader.vue?vue&type=template&id=1071736c&scoped=true"
import script from "./CheckpointHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointHeader.vue?vue&type=style&index=0&id=1071736c&prod&scoped=true&lang=css"
import style1 from "./CheckpointHeader.vue?vue&type=style&index=1&id=1071736c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071736c",
  null
  
)

export default component.exports